<script>
    export let row;
</script>

{#if row.descriptionTitle}
  <strong>{row.descriptionTitle}</strong>: {row.description}
{/if}
